import { render, staticRenderFns } from "./MessageRecord.vue?vue&type=template&id=a3238790&scoped=true&lang=pug&"
import script from "./MessageRecord.vue?vue&type=script&lang=js&"
export * from "./MessageRecord.vue?vue&type=script&lang=js&"
import style0 from "./MessageRecord.vue?vue&type=style&index=0&id=a3238790&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3238790",
  null
  
)

export default component.exports